// UI permissions are server-derived affordances only. Missing, malformed, or
// stale DTO data must never fall back to identity, role, creator, or assignee.
const EMPTY = Object.freeze({
  canRead: false,
  canMutate: false,
  canAssign: false,
  canDistribute: false,
  canManageStructure: false,
  canManageShowcase: false,
  canManageDictionaries: false,
});

function asBoolean(value) {
  return value === true;
}

export function resourcePermissions(dto) {
  const value = dto?.permissions;
  if (!value || typeof value !== 'object' || Array.isArray(value)) return EMPTY;
  return {
    canRead: asBoolean(value.canRead),
    canMutate: asBoolean(value.canMutate),
    canAssign: asBoolean(value.canAssign),
    canDistribute: asBoolean(value.canDistribute),
    canManageStructure: asBoolean(value.canManageStructure),
    canManageShowcase: asBoolean(value.canManageShowcase),
    canManageDictionaries: asBoolean(value.canManageDictionaries),
  };
}

export const canMutateResource = dto => resourcePermissions(dto).canMutate;
export const canDistributeObject = dto => resourcePermissions(dto).canDistribute;
export const canManageStructure = dto => resourcePermissions(dto).canManageStructure;
export const canManageShowcase = dto => resourcePermissions(dto).canManageShowcase;
export const canManageDictionaries = dto => resourcePermissions(dto).canManageDictionaries;
